if (!customElements.get('kh-studs-gallery-sync')) {
  customElements.define('kh-studs-gallery-sync', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('product-info');
      this.isOval = this.scope.dataset.url?.includes('oval-diamond-earrings');
      this.cache = new Map();
      this.version = 0;
      this.readSelection = () => {
        const picker = this.scope.querySelector('variant-selects');
        const weight = picker?.querySelector('select')?.selectedOptions[0]?.textContent.trim().split(' ')[0].replace(/ct$/, '');
        const selectedMetal = picker?.querySelector('input[data-option-name="Metal"]:checked')?.value.toLowerCase() || '';
        const metal = selectedMetal.includes('white') ? 'white-gold' : selectedMetal.includes('platinum') ? 'platinum' : 'yellow-gold';
        return this.scope.querySelector(`template[data-stud-front="${weight}"][data-stud-metal="${metal}"]`) || (this.scope.dataset.url?.includes("oval-diamond-earrings") ? this.scope.querySelector(`template[data-stud-front="${weight}"][data-stud-metal="yellow-gold"]`) : null);
      };
      this.copy = (target, original) => {
        if (!target || !original) return;
        ['src', 'srcset', 'sizes', 'alt', 'width', 'height'].forEach(attribute => {
          const value = original.getAttribute(attribute);
          if (value !== null) target.setAttribute(attribute, value);
          else target.removeAttribute(attribute);
        });
      };
      this.preload = (original, priority = 'low') => {
        const key = original.getAttribute('src');
        if (this.cache.has(key)) return this.cache.get(key);
        const image = new Image();
        image.fetchPriority = priority;
        image.sizes = original.sizes;
        image.srcset = original.srcset;
        image.src = original.src;
        const ready = image.decode().then(() => image).catch(() => null);
        this.cache.set(key, ready);
        return ready;
      };
      this.apply = async () => {
        const bank = this.readSelection();
        if (!bank) return;
        const key = bank.dataset.studFront + ':' + bank.dataset.studMetal;
        if (key === this.appliedKey) return;
        const version = ++this.version;
        const source = this.scope.querySelector('media-gallery');
        if (!source) return;
        const images = Array.from(bank.content.querySelectorAll('img'));
        const items = Array.from(source.querySelectorAll('.product__media-item'));
        const activeIndex = items.findIndex(item => item.classList.contains('is-active'));
        const activeImage = images[activeIndex];
        if (activeImage && !this.isOval) {
          const ready = await this.preload(activeImage, 'high');
          if (!ready) return;
        }
        if (version !== this.version || !this.isConnected) return;
        items.forEach((item, index) => this.copy(item.querySelector('.product__media img'), images[index]));
        source.querySelectorAll('.thumbnail img').forEach((image, index) => this.copy(image, images[index]));
        const modal = document.getElementById(`ProductModal-${this.dataset.section}`);
        modal?.querySelectorAll('.product-media-modal__content > img').forEach((image, index) => this.copy(image, images[index]));
        if (this.isOval) {
          const weight = bank.dataset.studFront;
          const frontScale = { '1': 0.95, '1.5': 0.96, '2': 0.95, '3': 0.9, '4': 0.97 }[weight] || 1;
          const detailScale = 1;
          const metal = { 'yellow-gold': 'yellow gold', 'white-gold': 'white gold', 'platinum': 'platinum' }[bank.dataset.studMetal];
          const views = ['front pair', 'angled pair', 'three-quarter setting', 'side profile', 'Alpha safety back', 'on ear'];
          const galleries = [items.map(item => item.querySelector('.product__media img')), Array.from(source.querySelectorAll('.thumbnail img')), Array.from(modal?.querySelectorAll('.product-media-modal__content > img') || [])];
          galleries.forEach(gallery => gallery.slice(0, 6).forEach((image, index) => {
            if (!image) return;
            const scale = index === 0 ? frontScale : index < 5 ? detailScale : 1;
            image.style.transform = scale === 1 ? '' : `scale(${scale})`;
            image.style.transformOrigin = index === 0 ? '50% 52%' : '50% 50%';
            image.alt = `Oval diamond earrings, illustrative ${weight}ct total pair — ${Number(weight) / 2}ct per earring — ${metal}, ${views[index]}`;
          }));
          images.forEach(image => this.preload(image, 'high'));
        }
        this.appliedKey = key;
      };
      this.onChange = event => {
        if (event.target.closest('variant-selects')) this.apply();
      };
      this.scope.addEventListener('change', this.onChange);
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data.sectionId) === this.dataset.section) this.apply();
      });
      if (this.isOval) {
        this.apply();
        const queue = [];
        const seen = new Set();
        this.scope.querySelectorAll('template[data-stud-front]').forEach(bank => {
          const images = Array.from(bank.content.querySelectorAll('img'));
          [images[0], images[5]].filter(Boolean).forEach(image => {
            if (!seen.has(image.src)) {
              seen.add(image.src);
              queue.push(image);
            }
          });
        });
        const warm = async () => {
          while (queue.length && this.isConnected) await this.preload(queue.shift());
        };
        const startWarm = () => { warm(); warm(); };
        if ('requestIdleCallback' in window) requestIdleCallback(startWarm, { timeout: 1500 });
        else setTimeout(startWarm, 0);
      } else {
        this.scope.querySelectorAll('template[data-stud-front]').forEach(bank => {
          const images = Array.from(bank.content.querySelectorAll('img'));
          [images[0], images[5]].filter(Boolean).forEach(image => this.preload(image));
        });
      }
    }
    disconnectedCallback() {
      ++this.version;
      this.unsubscribe?.();
      this.scope?.removeEventListener('change', this.onChange);
    }
  });
}
